import axios from "axios";
import { useContext, useState } from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
import "../../../assets/css/customer/cart/CartItem.css";
import AppContext from "../../../context/AppContext";

const CartItem = ({ item, onRefresh, viewCart }) => {
  const { baseUrl, baseUrlForFile, authToken, setCartCount, loggedInCustomer } =
    useContext(AppContext);

  const [adproduct_id] = useState(item.adproduct_id);
  const [quantity, setQuantity] = useState(item.quantity);
  const [price] = useState(item.price);

  const itemTotal = quantity * price;

  // ── removeCartItem ────────────────────────────────────
  const removeCartItem = () => {
    const formdata = new FormData();
    formdata.append("adproduct_id", item.adproduct_id);
    formdata.append("adcustomer_id", loggedInCustomer?.id);

    axios
      .post(`${baseUrl}/customer/cart/removeCartItem`, formdata, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        setCartCount(response.data.cartCount);
        viewCart();
      })
      .catch((error) => console.log(error));
  };

  // ── updateQuantity ────────────────────────────────────
  const updateQuantityData = (newQuantity) => {
    const formdata = new FormData();
    formdata.append("adproduct_id", adproduct_id);
    formdata.append("quantity", newQuantity);
    formdata.append("price", price);
    formdata.append("adcustomer_id", loggedInCustomer?.id);

    axios
      .post(`${baseUrl}/customer/cart/updateQuantity`, formdata, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then(() => viewCart())
      .catch((error) => console.log(error));
  };

  const handleQuantityChange = (newQuantity) => {
    if (newQuantity >= 1 && newQuantity <= 10) {
      setQuantity(newQuantity);
      updateQuantityData(newQuantity);
    }
  };

  const handleRemove = () => {
    if (window.confirm(`Remove ${item.adproduct.name} from cart?`)) {
      removeCartItem();
    }
  };

  return (
    <div className="cart-item">
      {/* Product Image */}
      <div className="cart-item-image">
        <img
          src={
            item.adproduct?.productimages?.length > 0
              ? `${baseUrlForFile}/${item.adproduct.productimages[0].image_path}`
              : "/placeholder.jpg"
          }
          alt={item.adproduct?.name}
        />
      </div>

      {/* Product Details */}
      <div className="cart-item-details">
        <h3 className="cart-item-name">{item.adproduct?.name || item.name}</h3>
        <p className="cart-item-category">
          {item.adproduct?.adcategory?.name || item.category}
        </p>
        <p className="cart-item-unit-price">
          Rs. {Number(price).toLocaleString()} / item
        </p>
      </div>

      {/* Quantity Controls */}
      <div className="cart-item-quantity">
        <label>Quantity</label>
        <div className="quantity-controls">
          <button
            className="quantity-btn"
            onClick={() => handleQuantityChange(quantity - 1)}
            disabled={quantity <= 1}
          >
            −
          </button>
          <input
            type="number"
            className="quantity-input"
            value={quantity}
            onChange={(e) =>
              handleQuantityChange(parseInt(e.target.value) || 1)
            }
            min="1"
            max="10"
          />
          <button
            className="quantity-btn"
            onClick={() => handleQuantityChange(quantity + 1)}
            disabled={quantity >= 10}
          >
            +
          </button>
        </div>
      </div>

      {/* Item Total */}
      <div className="cart-item-total">
        <p className="total-label">Total</p>
        <p className="total-amount">Rs. {itemTotal.toLocaleString()}</p>
      </div>

      {/* Remove Button */}
      <button
        className="cart-item-remove"
        onClick={handleRemove}
        aria-label="Remove item"
      >
        <RiDeleteBin6Line />
      </button>
    </div>
  );
};

export default CartItem;
